module.exports = __webpack_public_path__ + "media/images/smiling-baby-568f4455711ae1d53a349b9e11ed6b9a.png";